import Image from "next/image";
import { useCallback } from "react";
import { BsInfoCircle } from "react-icons/bs";
import type { alertType } from "utils";
import { paymentOptionsAssets } from "../../../apps/dashboard/src/helpers/config";

interface IAlertProps {
  message?: string;
  type: alertType;
  className?: string;
  children?: React.ReactNode;
  width?: number;
}

interface IAlertWrapperProps {
  type: string;
  children: React.ReactNode;
  className?: string;
  width?: number;
}

export function AlertSimple({
  message,
  type,
  className,
  children,
  width,
}: IAlertProps): JSX.Element {
  return (
    <AlertWrapper className={className} type={type} width={width}>
      <div>
        {message ? <div className="text-xxl">{message}</div> : children}
      </div>
    </AlertWrapper>
  );
}

// WRAPPER

function AlertWrapper({
  type,
  children,
  className,
  width,
}: IAlertWrapperProps): JSX.Element {
  const iconWidth = width || paymentOptionsAssets.warning.width;
  const getConfig = useCallback(() => {
    switch (type) {
      case "success":
        return {
          src: paymentOptionsAssets.success.src,
          width: iconWidth,
        };
      case "warning":
        return {
          src: paymentOptionsAssets.warning.src,
          width: iconWidth,
        };
      case "error":
        return {
          src: paymentOptionsAssets.error.src,
          width: iconWidth,
        };
      default:
        return { icon: BsInfoCircle, alertType: "" };
    }
  }, [type, iconWidth]);
  return (
    <div className={`flex items-center ${className || ""}`}>
      <Image
        src={getConfig().src}
        width={getConfig().width}
        height={getConfig().width}
        alt={type}
        className="inline-block mr-2"
      />
      <div className="inline-block">{children}</div>
    </div>
  );
}
